<div>
  <h5
    style="font-weight: 400; margin-top: 1rem; padding: 2rem 2rem 0 2rem; font-size: 1rem"
  >
    {{ 'utilities.filesControl.history.description' | translate }}
  </h5>
  <div style="padding: 2rem">
    <div>
      <div>
        {{
          'record.recordsCount'
            | translate
              : { count: tableData?.length || '0', total: collectionSize }
        }}
      </div>
    </div>
    <div class="d-flex justify-content-center loader" *ngIf="isLoading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div>
      <table class="table table-striped" *ngIf="!isLoading && tableData?.length > 0">
        <thead>
          <tr>
            <th scope="col">
              {{ 'utilities.filesControl.history.operation' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.filesControl.history.user' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.filesControl.history.date' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.filesControl.history.origin' | translate }}
            </th>
            <th scope="col">
              {{ 'utilities.filesControl.history.destiny' | translate }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            style="height: 50px; overflow: scroll"
            *ngFor="let data of tableData"
          >
            <td>{{ data.operation }}</td>
            <td>{{ data.user }}</td>
            <td>{{ formatDateTable(data.date) }}</td>
            <td>{{ data.sender }}</td>
            <td>{{ data.receivers }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      *ngIf="tableData?.length <= 0 && !isLoading"
      class="d-flex justify-content-center"
    >
      <span>{{ 'noDataAvailable' | translate }}</span>
    </div>

    <div class="d-flex justify-content-center p-2" *ngIf="tableData?.length > 0">
      <ngb-pagination
        [collectionSize]="collectionSize"
        [(page)]="page"
        [pageSize]="pageSize"
        [rotate]="true"
        [maxSize]="5"
        [ellipses]="false"
        [boundaryLinks]="true"
        (pageChange)="refreshData()"
      >
      </ngb-pagination>

      <!--
      <select class="custom-select" style="width: auto" name="pageSize" [(ngModel)]="service.pageSize">
        <option [ngValue]="2">2 items per page</option>
        <option [ngValue]="4">4 items per page</option>
        <option [ngValue]="6">6 items per page</option>
      </select>
      -->
    </div>
  </div>
</div>
